export default __webpack_public_path__ + "static/poster-524b2ab8206aadcb664b87419ab6af52.png";